/**
 * Per-user comment display preferences (board card z2ex addition): whether
 * comments are hidden altogether and whether resolved threads show. Kept in
 * localStorage under the user id; defaults = comments shown, resolved hidden.
 */
export interface CommentPrefs {
  hidden: boolean
  showResolved: boolean
}

export const DEFAULT_COMMENT_PREFS: CommentPrefs = { hidden: false, showResolved: false }

function key(userId: string | undefined): string {
  return `hub:commentPrefs:v1:${userId ?? 'anonymous'}`
}

export function readCommentPrefs(userId: string | undefined): CommentPrefs {
  try {
    const raw = window.localStorage.getItem(key(userId))
    if (!raw) return DEFAULT_COMMENT_PREFS
    const parsed = JSON.parse(raw) as Partial<CommentPrefs>
    return {
      hidden: parsed.hidden === true,
      showResolved: parsed.showResolved === true,
    }
  } catch {
    return DEFAULT_COMMENT_PREFS
  }
}

export function writeCommentPrefs(userId: string | undefined, prefs: CommentPrefs): void {
  try {
    window.localStorage.setItem(key(userId), JSON.stringify(prefs))
  } catch {
    // private mode / quota — the choice just does not persist
  }
}
